import '../Match.css';
import { HasMatchState } from '../MatchStateViewer';

import '@fontsource/norwester';
import { Stack } from '@mui/material';
import { InLine } from '../../../../cards/playerCards/CardDimensions';
import { AnimatedStack } from '../../../../MotionMui/MotionMui';
import { useMatchViewState } from '../matchViewContext/MatchViewContext';
import { MatchClock } from './MatchClock';
import { TeamScoreCardComponent } from './TeamScoreCard';

export const ScoreboardComponent = (props: HasMatchState) => {
  const homeTeam = props.matchState.teams[props.matchState.homeTeam];
  const awayTeam = props.matchState.teams[props.matchState.awayTeam];
  return (
    <AnimatedStack
      direction="row"
      staggerSpeed={'Fast'}
      justifyContent="center"
      spacing={1}
      alignItems={'center'}
    >
      <Stack width="40%">
        <TeamScoreCardComponent
          team={homeTeam}
          dimensions={InLine}
          avatarSide="left"
        />
      </Stack>
      <MatchClock matchState={props.matchState} dimensions={InLine} />
      <Stack width="40%">
        <TeamScoreCardComponent
          team={awayTeam}
          dimensions={InLine}
          avatarSide="right"
        />
      </Stack>
    </AnimatedStack>
  );
};

export const ContextualScoreboard = () => {
  const matchViewContext = useMatchViewState();
  return (
    <ScoreboardComponent
      matchState={{
        ...matchViewContext.scoreState,
      }}
    />
  );
};
